// extracted by mini-css-extract-plugin
export default {"pipelineSuggestions":"ProfileInPipelines_pipelineSuggestions__QyewZ","suggestionHeader":"ProfileInPipelines_suggestionHeader__86xYH"};